<template>
<div>
    <div class="default-settings-title">
        <span class="account-name">Step 4: Databases to backup</span>
        <span v-if="!fetchingDatabases" class="default-settings-subtitle">Select the databases you want to backup. <span @click="selectAllDatabases" style="text-decoration: underline; cursor: pointer;">Select all</span> / <span @click="unselectAllDatabases" style="text-decoration: underline; cursor: pointer">Unselect all</span></span>
        <span v-if="fetchingDatabases" class="default-settings-subtitle">Fetching databases...</span>
    </div>

    <div class="columns">
        <div class="column is-full has-text-centered m-top-10 m-bottom-10" v-if="fetchingDatabases">
            <img src="/loader-dark.svg">
        </div>
        <div v-if="!fetchingDatabases" class="column is-full" style="margin-top: 10px;">
            <!-- <div style="color: #353b48;">Databases to backup</div>
            <div style="color: #868e96; margin-bottom: 15px; font-size: 13px;">Select one or more databases you want to backup. <</div> -->
            <div class="columns is-multiline">
                <div v-if="nothingToShow" class="column is-full">
                    <div class="notification" style="font-size: 13px;">
                        {{ nothingToShow }}
                    </div>
                </div>
                <div v-if="!nothingToShow" @click="toggleEnableDatabasesAutoSynchronization" class="column is-full">
                    <div class="field">
                        <input v-model="enableDatabasesAutoSynchronization" type="checkbox" class="switch is-rounded is-info">
                        <label style="margin-top:-15px; font-size: 15px;">
                            Auto-synchronize the databases running on the server <b>{{ server.name }}.</b>
                            <span v-if="enableDatabasesAutoSynchronization" style="display:block;font-size:12px;margin-left:55px;">Weap.io will automatically import every new database found on your server and will remove from the Weap.io dashboard the databases that have been deleted from your server.</span>
                            <span v-if="!enableDatabasesAutoSynchronization" style="display:block;font-size:12px;margin-left:55px;">Only the databases selected below will be imported in your Weap.io dashboard.</span>
                        </label>
                    </div>
                </div>
                <div class="column is-4" v-for="database in filteredDatabases" v-bind:key="database.name">
                    <div @click="toggleDatabaseSelection(database)" class="server-widget tooltip" :data-tooltip="databaseSelectionTooltip(database)" style="cursor: pointer;" :class="{ 'server-widget-selected-border': databaseIsSelected(database) }">
                        <div class="server-name">{{ database.name }}</div>
                        <div class="server-host">
                            <font-awesome-icon icon="database"/>&nbsp;&nbsp;{{ getFormattedDatabaseType }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="columns is-multiline">
        <div class="column is-4">
            <div @click="backupSelectedDatabases" class="button custom-button-size is-fullwidth is-info" :class="{ 'is-loading': storingDatabases }" :disabled="backupSelectedDatabasesIsDisabled">Backup selected databases</div>
        </div>
        <div class="column is-3">
            <div @click="close" class="close-add-monitor-modal button custom-button-size is-fullwidth is-danger" :disabled="cancelIsDisabled">Cancel</div>
        </div>
    </div>
</div>
</template>

<script>
import Api from '@/api';

export default {
    props: {
        server: Object,
        credentials: Object,
        databaseType: String, 
    },

    data() {
        return {
            databases: [],
            selectedDatabases: [],
            fetchingDatabases: false,
            storingDatabases: false,
            enableDatabasesAutoSynchronization: false,
        }
    },

    mounted() {
        this.getLiveDatabases(() => {
            this.enableDatabasesAutoSynchronization = this.server.auto_synchronize_databases;
        });
    },

    methods: {
        getLiveDatabases(successCallback) {
            if (this.fetchingDatabases) {
                return;
            }

            this.fetchingDatabases = true;
            let endpoint = 'servers/' + this.server.id + '/live-databases/' + this.databaseType;

            Api().get(endpoint, { params: this.credentials })
                .then((success) => {
                    this.databases = success.data.databases;
                    if (typeof successCallback == 'function') {
                        successCallback();
                    }
                })
                .catch((error) => {
                    if (!this.storeErrors(error.response.data.errors)) {
                        if (typeof error.response.data.message == 'string') {
                            this.error = error.response.data.message;
                        } else {
                            this.error = 'Something wrong happened. Refresh the page and try again.';
                        }
                    }
                })
                .finally(() => {
                    this.fetchingDatabases = false;
                });
        },

        backupSelectedDatabases() {
            if (this.backupSelectedDatabasesIsDisabled) {
                return;
            }

            this.storingDatabases = true;

            // Set the auto-sync
            Api().put('servers/' + this.server.id + '/databases-auto-synchronization', { auto_synchronize_databases: this.enableDatabasesAutoSynchronization, backups_behaviour: this.server.backups_behaviour })
                .then((success) => {
                    //
                })
                .catch((error) => {
                    //
                });

            // Add the databases to backup
            let endpoint = 'servers/' + this.server.id + '/databases/' + this.databaseType;

            Api().post(endpoint, this.databasesToBackup)
                .then((success) => {
                    if (this.selectedDatabases.length > 1) {
                        Event.$emit('closeAddDatabase');
                        swal('Great!', 'The databases have been added. Have a look at the backup & retention policy of each database and change it based on your requirements.', 'success');
                    } else {
                        this.$router.push({ name: 'showDatabase', params: { id: success.data.data[0].id } });
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.storingDatabases = false;
                });
        },

        toggleEnableDatabasesAutoSynchronization() {
            this.enableDatabasesAutoSynchronization = !this.enableDatabasesAutoSynchronization;
        },

        toggleDatabaseSelection(database) {
            if (database.exists || this.storingDatabases || this.enableDatabasesAutoSynchronization) {
                return;
            }

            if (this.databaseIsSelected(database)) {
                this.unselectDatabase(database);
            } else {
                this.selectDatabase(database);
            }
        },

        databaseIsSelected(database) {
            return this.selectedDatabases.includes(database);
        },

        selectAllDatabases() {
            this.unselectAllDatabases();
            for (var i = 0; i < this.filteredDatabases.length; i++) {
                this.selectDatabase(this.filteredDatabases[i]);
            }
        },

        unselectAllDatabases() {
            this.selectedDatabases = [];
        },

        selectDatabase(database) {
            this.selectedDatabases.push(database);
        },

        unselectDatabase(database) {
            let index = this.selectedDatabases.indexOf(database);

            if (index > -1) {
                this.selectedDatabases.splice(index, 1);
            }
        },

        close() {
            if (this.cancelIsDisabled) {
                return;
            }

            Event.$emit('closeAddDatabase');
        },

        databaseSelectionTooltip(database) {
            if (this.enableDatabasesAutoSynchronization) {
                return 'Disable auto-synchronization to unselect the database.';
            }

            if (this.databaseIsSelected(database)) {
                return 'Click to deselect this database.';
            }

            return 'Click to select this database.';
        },
    },

    computed: {
        backupSelectedDatabasesIsDisabled() {
            if (this.fetchingDatabases) {
                return true;
            }

            if (this.selectedDatabases.length == 0) {
                return true;
            }

            if (this.storingDatabases) {
                return true;
            }

            return false;
        },

        cancelIsDisabled() {
            if (this.fetchingDatabases) {
                return true;
            }

            if (this.storingDatabases) {
                return true;
            }

            return false;
        },

        databasesToBackup() {
            var databases = [];

            for (var i = 0; i < this.selectedDatabases.length; i++) {
                databases.push({
                    'name': this.selectedDatabases[i].name,
                    'host': this.credentials.host,
                    'user': this.credentials.user,
                    'port': this.credentials.port,
                    'password': this.credentials.password,
                });
            }

            return {
                databases: databases,
            };
        },

        filteredDatabases() {
            var filtered = [];

            for (var i = 0; i < this.databases.length; i++) {
                if (!this.databases[i].exists) {
                    filtered.push(this.databases[i]);
                }
            }

            return filtered;
        },

        nothingToShow() {
            if (this.databases.length > 0 && this.filteredDatabases.length < 1) {
                return 'All databases found on this server are already imported.';
            }

            if (!this.databases.length) {
                return 'We could not find any databases on this server.';
            }
        },

        getFormattedDatabaseType() {
            if (this.databaseType == 'mysql') {
                return 'MySQL database';
            }

            if (this.databaseType == 'postgresql') {
                return 'PostgreSQL database';
            }

            return '-';
        },
    },  

    watch: {
        enableDatabasesAutoSynchronization(enableDatabasesAutoSynchronization) {
            // All databases should be selected
            if (enableDatabasesAutoSynchronization) {
                for (var i = 0; i < this.filteredDatabases.length; i++) {
                    if (!this.databaseIsSelected(this.filteredDatabases[i])) {
                        this.selectDatabase(this.filteredDatabases[i]);
                    }
                }
                return;
            }

            // All databases should be unselected
            for (var i = 0; i < this.filteredDatabases.length; i++) {
                if (this.databaseIsSelected(this.filteredDatabases[i])) {
                    this.unselectDatabase(this.filteredDatabases[i]);
                }
            }
        }
    }
}
</script>